import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#111827",
      d: "M14.02 14.07a.75.75 0 0 1 1.28.53v.75a1.5 1.5 0 0 1-1.5 1.5h-12a1.5 1.5 0 0 1-1.5-1.5v-12a1.5 1.5 0 0 1 1.5-1.5h7.75a.75.75 0 1 1 0 1.5H1.8v12h12v-.75a.75.75 0 0 1 .22-.53"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#111827",
      d: "M4.762 6.895c.11-.11.258-.171.413-.171H8.84a.583.583 0 0 1 .584.583v3.667a.583.583 0 0 1-1.167 0V8.716l-3.587 3.587a.584.584 0 0 1-.825-.825L7.433 7.89H5.175a.583.583 0 0 1-.413-.995"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#111827",
      "fill-rule": "evenodd",
      d: "M13.3 12.55a1.7 1.7 0 0 1-1.7-1.7v-9a1.7 1.7 0 0 1 1.7-1.7h3a1.7 1.7 0 0 1 1.7 1.7v9a1.7 1.7 0 0 1-1.7 1.7zm-.3-1.7a.3.3 0 0 0 .3.3h3a.3.3 0 0 0 .3-.3v-9a.3.3 0 0 0-.3-.3h-3a.3.3 0 0 0-.3.3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }